import {
  DimensionVideoListModel,
  DimensionWpPost,
} from '../models/DimensionVideoListModel';

export type DimensionClassState = {
  currentState: DimensionClassStateType;
  pageNumber: number;
  videoList?: DimensionVideoListModel;
};

export enum DimensionClassStateType {
  LOADING,
  LOADED,
  LOAD_MORE,
  ERROR,
}

export type DimensionClassAction = {
  type: DimensionClassStateType;
  payload?: DimensionClassPayload;
};
export type DimensionClassPayload = {
  pageNumber: number;
  videoList?: DimensionVideoListModel;
};

export const DimensionClassReducer = (
  draft: DimensionClassState,
  action: DimensionClassAction,
) => {
  const { type, payload } = action;
  switch (type) {
    case DimensionClassStateType.LOADING:
      draft.currentState = type;
      draft.pageNumber = 1;
      break;
    case DimensionClassStateType.LOADED: {
      draft.currentState = type;
      draft.pageNumber = payload?.pageNumber ?? 1;
      const isFirstPage = payload?.pageNumber === 1;
      draft.videoList = {
        introductionPost: (isFirstPage
          ? payload?.videoList?.introductionPost
          : draft.videoList?.introductionPost) as DimensionWpPost,
        hasMore: payload?.videoList?.hasMore ?? false,
        videos: isFirstPage
          ? payload?.videoList?.videos ?? []
          : [
              ...(draft.videoList?.videos ?? []),
              ...(payload?.videoList?.videos ?? []),
            ],
      };
      break;
    }
    case DimensionClassStateType.LOAD_MORE:
    case DimensionClassStateType.ERROR:
      draft.currentState = type;
      draft.pageNumber = payload?.pageNumber ?? 1;
      break;
    default:
      draft.currentState = type;
      draft.pageNumber = payload?.pageNumber ?? 1;
      break;
  }
};
